import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

const TransLink = (props) => {
  
  var url = props.url;
  if (props.lang !== props.defaultLang) {
    url = props.url.charAt(0) === '/' ? `/${props.lang}${props.url}` : `/${props.lang}/${props.url}`;
  }
  const name = props.name || props.children;
  if (props.key && props.className) {
    if (props.target) {
      return <Link to={url} key={props.key} className={props.className} target={props.target}>{ name }</Link>;
    }

    return <Link to={url} id={props.id}  key={props.key} className={props.className}>{ name }</Link>;
  }

  if (props.key) {
    if (props.target) {
      return <Link to={url} key={props.key} target={props.target}>{ name }</Link>;
    }

    return <Link to={url} key={props.key}>{ name }</Link>;
  }

  if (props.className) {
    if (props.target) {
      return <Link to={url} className={props.className} target={props.target}>{ name }</Link>;
    }
    if (props.id) {
      return <Link to={url} id={props.id} className={props.className}>{ name }</Link>;
    }
    return <Link to={url} className={props.className}>{ name }</Link>;
  }

  if (props.target) {
    return <Link to={url} target={props.target}>{ name }</Link>;
  }

  if(props.isPromoPage) {
    return <Link to={{ pathname: url, state: {routePath: props.routePath}}}>{ name }</Link>;
  }

  return <Link to={url}>{ name }</Link>;
};

const mapStateToProps = state => ({ lang: state.langCode, defaultLang: state.defaultLangCode });

export default connect(mapStateToProps)(TransLink);



// WEBPACK FOOTER //
// ./src/Common/Translations/TransLink.js